module.exports = __webpack_public_path__ + "img/heartsArrows-1@2x.0bffae0.png";